import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import { useLocale } from 'next-intl';
import styled from 'styled-components';

import Link from '@/ui/components/Link';
import { urlBuilder } from '@/utils/urlBuilder';

const Badge = styled.div`
  background-color: ${props => props.theme.palette.gray.light};
  color: black;
  text-transform: none;
  display: flex;
  padding: 0.375rem 0.625rem 0.3125rem 0.625rem;
  align-items: flex-start;
  gap: 0.625rem;
  border-radius: 0.1875rem;
  background: ${props => props.theme.palette.gray.light};
  margin-right: 0.5rem;
  text-align: center;
  font-size: 0.75rem;
  line-height: normal;
  letter-spacing: 0.0375rem;
  text-transform: uppercase;
  white-space: nowrap;
  text-decoration: none;
`;

const PlusWrapper = styled(Badge)`
  cursor: pointer;
`;

export const PlusButton = ({ onClickAction }) => {
  return (
    <PlusWrapper onClick={onClickAction}>
      <span>+</span>
    </PlusWrapper>
  );
};

/**
 * @todo refactor to mui button
 */
export default function ProductBadge({ product, noLink = false }) {
  // <Button
  //         key={product.id}
  //         variant="contained"
  //         sx={{
  //           backgroundColor: '#f5f5f5',
  //           color: 'black',
  //           textTransform: 'none',
  //           marginRight: 1,
  //         }}
  //       >
  //         {product.title}
  //       </Button>

  const locale = useLocale();

  const url = React.useMemo(() => urlBuilder({ item: product, locale, silent: true }), [product?.slug]);

  if (!noLink && url) {
    return (
      <Link href={url}>
        <Badge>{product.title}</Badge>
      </Link>
    );
  }

  if (product.childrens) {
    const childrenNames = product.childrens.map(child => child.title).join(', ');

    return (
      <Tooltip title={childrenNames} placement="top" arrow>
        <div>
          <Badge>{product.title}</Badge>
        </div>
      </Tooltip>
    );
  }

  return <Badge>{product.title}</Badge>;
}
